import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaCaretRight } from "react-icons/fa";
import { toast } from "react-toastify";
import parse from "html-react-parser";

function ListFaq() {
  const [openIndex, setOpenIndex] = useState(null);
  const [faq, setFaq] = useState([]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchFaq = async () => {
      try {
        const response = await axios.get("/api_w/faq");
        if (response.data.data.length > 0) {
          setFaq(response.data.data);
        } else {
          setFaq([
            {
              title: "Apa peringkat akreditasi Madrasah Jateng Digital Learning?",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
            },
            {
              title: "Apa sistem kurikulum yang digunakan?",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
            },
            {
              title: "Apa saja sumber belajar yang digunakan?",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
            },
            {
              title: "Apa Madrasah Jateng Digital Learning memiliki program beasiswa?",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
            },
          ]);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
        setFaq([
          {
            title: "Apa peringkat akreditasi Madrasah Jateng Digital Learning?",
            description:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
          },
          {
            title: "Apa metode belajar yang digunakan?",
            description:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
          },
          {
            title: "Apa saja sumber belajar yang digunakan?",
            description:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
          },
          {
            title: "Apa Sekolah Islam Cendekia Harapan memiliki program beasiswa?",
            description:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
          },
        ]);
      }
    };

    fetchFaq();
  }, []);

  return (
    <div>
      <div className="mb-6 flex items-center justify-center">
        <h3 className="text-2xl">
          <span className="border-b-2 border-blue-500 font-bold hover:cursor-pointer hover:text-blue-700">
            Frequently Asked Questions
          </span>
        </h3>
      </div>
      <div
        id="accordion-collapse"
        data-accordion="collapse"
        className="p-4 md:pl-10 md:pr-10"
      >
        {faq.map((item, index) => (
          <div key={index}>
            <h2 id={`accordion-collapse-heading-${index + 1}`}>
              <button
                type="button"
                className={`flex w-full items-center border border-b-2 p-5 font-semibold ${
                  openIndex === index
                    ? "rounded-t-xl text-blue-600"
                    : "text-gray-800"
                } gap-3`}
                onClick={() => toggleAccordion(index)}
                aria-expanded={openIndex === index}
                aria-controls={`accordion-collapse-body-${index + 1}`}
              >
                <span className="flex items-center">
                  <FaCaretRight
                    className={`transition-transform duration-200 ${
                      openIndex === index ? "rotate-90" : ""
                    } mr-2`}
                  />
                  {item.title}
                </span>
              </button>
            </h2>
            <div
              id={`accordion-collapse-body-${index + 1}`}
              className={`${
                openIndex === index ? "block" : "hidden"
              } border border-b-2 p-5`}
              aria-labelledby={`accordion-collapse-heading-${index + 1}`}
            >
              <p className="mb-2">{parse(item.description)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ListFaq;
